import { DetailSkeleton, ErrorState } from '@/components/ui/states'
import { requestErrorMessage } from '@/helpers/apiClient'
import { useSalesPriceList } from '@/hooks/useSales'
import { PriceListEditor } from './PriceListEditor'

/** The price list pane of a venue's settings (docs/sales.spec.md, "The price list"). */
export function VenuePriceListSection({ venueId }: { venueId: string }) {
  const query = useSalesPriceList(venueId)
  if (query.isPending) return <DetailSkeleton />
  if (query.isError) return <ErrorState message={requestErrorMessage(query.error)} onRetry={() => void query.refetch()} />
  // Re-made from each saved copy, so new rows pick up the ids they were given.
  return <PriceListEditor key={query.dataUpdatedAt} venueId={venueId} list={query.data} />
}
